export default {
  sandboxLogoutMemo: "",
  isImportInProgress: false,
  isUserImportingToDictionary: false,
  inquiryInfo: {},
};
